import { render, staticRenderFns } from "./UsageSummarySmallCard.vue?vue&type=template&id=229204b2"
import script from "./UsageSummarySmallCard.vue?vue&type=script&lang=js"
export * from "./UsageSummarySmallCard.vue?vue&type=script&lang=js"
import style0 from "./UsageSummarySmallCard.vue?vue&type=style&index=0&id=229204b2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports